import { ReferralType } from '@wix/da-bi/pkg/constants';
export const moduleTypeToReferralType = (moduleType)=>{
    switch(moduleType){
        case 'papiCustombox':
            return ReferralType.CUSTOM_BOX;
        case 'userstats':
            return ReferralType.USER_STATS;
        default:
            return undefined;
    }
};

//# sourceMappingURL=helpers.js.map